import { createSlice } from "@reduxjs/toolkit";
import { fetchRecipes } from "./searchResultsThunk";

const initialState = {
  loading: false,
  allRecipes: [],
  filteredRecipes: [],
  query: "",
  ingredients: [],
  hasSearched: false,
  error: null,
};

const filterMatches = (recipes, ingredients) => {
  if (ingredients.length === 0) return recipes;

  return recipes.filter((recipe) => {
    const ingredientText =
      recipe.extendedIngredients
        ?.map((i) => i.original)
        ?.join(" ")
        ?.toLowerCase() || "";

    return ingredients.every((ing) =>
      ingredientText.includes(ing.toLowerCase())
    );
  });
};

const searchResultsSlice = createSlice({
  name: "searchResults",
  initialState,
  reducers: {
    resetSearchState: (state) => {
      Object.assign(state, initialState);
    },
    updateIngredientsAndFilter: (state, action) => {
      state.ingredients = action.payload;
      const matches = filterMatches(state.allRecipes, state.ingredients);
      state.filteredRecipes = matches;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchRecipes.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchRecipes.fulfilled, (state, action) => {
        state.loading = false;
        state.hasSearched = true;
        state.allRecipes.push(...action.payload);
        const matches = filterMatches(state.allRecipes, state.ingredients);
        state.filteredRecipes = matches;
      })
      .addCase(fetchRecipes.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to fetch recipes";
      });
  },
});

export const { resetSearchState, updateIngredientsAndFilter } =
  searchResultsSlice.actions;

export default searchResultsSlice.reducer;
